/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdatePhoneNumberRequestDto } from '../../models/update-phone-number-request-dto';
import { UpdatePhoneNumberResponseDto } from '../../models/update-phone-number-response-dto';

export interface UpdatePhoneNumberStep1$Params {
      body: UpdatePhoneNumberRequestDto
}

export function updatePhoneNumberStep1(http: HttpClient, rootUrl: string, params: UpdatePhoneNumberStep1$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdatePhoneNumberResponseDto>> {
  const rb = new RequestBuilder(rootUrl, updatePhoneNumberStep1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdatePhoneNumberResponseDto>;
    })
  );
}

updatePhoneNumberStep1.PATH = '/api/v1/customer/phone-number/init';
